import { useMemo } from 'react'
import { NetworkStatus } from '@apollo/client'

import type { TVideoPost } from 'entities/videoPost'
import { usePostsQueries } from 'hooks-queries/posts'

import { DEFAULT_QUERY_FILTERS, GET_POSTS_FROM_TERRITORY_LOG } from './use-videos-by-territory.consts'
import type { UseVideosByTerritoryProps } from './use-videos-by-territory.types'

export function useVideosByTerritory({ territoryId, variables = DEFAULT_QUERY_FILTERS }: UseVideosByTerritoryProps) {
  const { data, networkStatus, error, refetch } = usePostsQueries({
    errorLog: GET_POSTS_FROM_TERRITORY_LOG,
    queryName: 'getVideosByTerritory',
    queryVariables: {
      territoryId,
      ...variables,
    },
    options: {
      skip: !territoryId,
    },
  })

  const videos = useMemo(() => {
    const responseData = Array.from(data?.getTerritory?.territoryMostEngaged?.posts || [])
    const parsedVideos: TVideoPost[] = responseData.map((video: any) => {
      return {
        postId: video?.postId,
        title: video?.title,
        provider: video?.provider,
        thumbnail: video?.thumbnail,
        publishedAt: video?.publishedAt,
        tags: video?.tags || [],
        views: video?.views,
        likes: video?.likes,
        comments: video?.comments,
        creatorId: video?.creatorId,
        isPublicity: video?.isPublicity,
        live: video?.live,
        creator: {
          ...(video?.creator || {}),
          title: video?.creator?.title,
          thumbnail: video?.creator?.thumbnail,
          groupId: video?.creator?.groupId,
          creatorId: video?.creator?.creatorId,
        },
      }
    })

    return parsedVideos
  }, [data?.getTerritory?.territoryMostEngaged?.posts])

  const isLoading = [NetworkStatus.loading, NetworkStatus.setVariables].includes(networkStatus)

  const memoizedValues = useMemo(
    () => ({
      videos,
      isLoading,
      error,
      refetch,
    }),
    [error, isLoading, refetch, videos]
  )

  return memoizedValues
}
